import OrderPage from "./pages/Order";
import Dashboard from "./pages/Dashboard";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import { useEffect } from "react";
import LoginPage from "./pages/SignIn";
import PrivateRoute from "./PrivateRoute";
import PublicRoute from "./PublicRoute";
import Orders from "./pages/Orders";
import {MainHeader} from "./components/layout/MainHeader";
import { useLocation } from "react-router-dom";

const routeTitles = {
    "/": "Dashboard",
    "/dashboard": "Dashboard",
    "/orders": "Orders",
    "/order": "Order Details",
    "/signin": "Login"
};



function TitleManager() {
    const location = useLocation();

    useEffect(() => {
        let path = location.pathname;

        if (path.startsWith("/order/")) {
            document.title = routeTitles["/order"];
        } else {
            document.title = routeTitles[path] || "Dashboard";
        }
    }, [location]);

    return null;
}

export default function App() {
    useEffect(() => {
        const unlock = () => {
            const audio = new Audio();
            audio.play().catch(() => {});
        };
        document.addEventListener("click", unlock, { once: true });
    }, []);

    return (
        <>
            <BrowserRouter>
                <TitleManager />
                <Routes>
                    <Route element={<PrivateRoute />}>
                        <Route element={<MainHeader />}>
                            <Route element={<Dashboard />} index />
                            <Route path="dashboard" element={<Dashboard />} />
                            <Route path="/orders" element={<Orders />} />
                            <Route path="/order/:orderId" element={<OrderPage />} />
                        </Route>
                    </Route>
                    <Route element={<PublicRoute />}>
                        <Route path="/signin" element={<LoginPage />} />
                    </Route>
                </Routes>
            </BrowserRouter>
        </>
    );
}